<template>
    <div style="width:100%" class="mb-4">

        <v-card class="mx-auto mb-4" width="100%">
            <v-card-text>
                <div class="text-h5">StatusHub Coms</div>
            </v-card-text>

            <div class="pa-4">

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Affecting</v-list-item-title>
                        <v-list-item-subtitle>{{ data.affecting }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Description</v-list-item-title>
                        <v-list-item-subtitle>{{ data.issue }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Description</v-list-item-title>
                        <v-list-item-subtitle>{{ data.issue }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Root Cause</v-list-item-title>
                        <v-list-item-subtitle>{{ data.statushubIncidentTitle }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Coms</v-list-item-title>
                        <v-list-item-subtitle v-html="data.statushubNotificationHistory"></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Time To Resolve</v-list-item-title>
                        <v-list-item-subtitle>{{ calculatedTimeToResolveMinutes }} Min</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Acknowledged By</v-list-item-title>
                        <v-list-item-subtitle>{{ data.pagerdutyAcknowledgedBy }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Assigned To</v-list-item-title>
                        <v-list-item-subtitle>{{ data.pagerdutyAssignedTo }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Pager Duty Times</v-list-item-title>
                        <v-list-item-subtitle>
                            <v-chip class="ma-1 primary" small>
                                Time To Ackowledge: {{ timeToAcknowledgeMinutes }} Min
                            </v-chip>

                            <v-chip class="ma-1 primary" small>
                                Time To Set Sev: {{ timeToSetSevMinutes }} Min
                            </v-chip>

                            <v-chip class="ma-1 primary" small>
                                Time To Send Comms: {{ timeToSendCommsMinutes }} Min
                            </v-chip>

                            <v-chip class="ma-1 primary" small>
                                Time To Recover: {{ timeToResolveMinutes }} Min
                            </v-chip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </div>

            <!--<v-card-actions>
                <v-btn text
                       color="accent"
                       @click="onOpenKibana">
                    Details in Kibana: {{$route.params.id }}
                </v-btn>
            </v-card-actions>-->
        </v-card>
    </div>
</template>

<script>

    export default {
        name: 'ElasticInfo',
        data: function () {
            return {

            }
        },
        components: {

        },
        props: {
            data: {
                default: () => ({
                    id: "",
                    logged: "",
                    entity: "",
                    alertSource: "",
                    class: "",
                    computedTimeToAcknowledgeTotalSeconds: 0,
                    computedTimeToAcknowledgeUserSeconds: 0,
                    computedTimeToResolveTotalSeconds: 0,
                    computedTimeToSendCommsTotalSeconds: 0,
                    computedTimeToSendCommsUserSeconds: 0,
                    computedTimeToSetSevSeconds: 0,
                    element: "",
                    elementtype: "",
                    elementSubtype: "",
                    issue: "",
                    metriclyIncidentKey: "",
                    pagerdutyAcknowledgedBy: "",
                    pagerdutyAssignedTo: "",
                    pagerdutyResolvedBy: "",
                    pagerdutyId: "",
                    pagerdutyIncidentNumber: "",
                    pagerdutyIncidentStatus: "",
                    pagerdutyPriority: "",
                    pagerdutyTeam: "",
                    pagerdutyTitle: "",
                    pagerdutyUrgency: "",
                    pagerdutyEscalationPolicy: "",
                    remedyIncidentNumber: "",
                    results: "",
                    gamingServer: "",
                    site: "",
                    statushubCalculatedTimeToMonResSeconds: 0,
                    statushubComms: "",
                    statushubIncidentId: "",
                    statushubIncidentStart: "",
                    statushubIncidentTitle: "",
                    statushubNotificationHistory: "",
                    statushubStatus: "",
                    type: "",
                    affecting: "",
                    statushubIc: "",
                    statushubSme: "",
                    statushubIncidentResolved: ""
                }),
                type: Object
            },
        },
        computed: {
            calculatedTimeToResolveMinutes() {
                var seconds = this.data.statushubCalculatedTimeToMonResSeconds ? this.data.statushubCalculatedTimeToMonResSecond : 0;
                return parseInt(seconds / 60);
            },
            timeToResolveMinutes() {
                var seconds = this.data.computedTimeToResolveTotalSeconds === null ? this.data.computedTimeToResolveTotalSeconds : 0;
                return parseInt(seconds / 60);
            },
            timeToAcknowledgeMinutes() {
                var seconds = this.data.computedTimeToAcknowledgeTotalSeconds === null ? this.data.computedTimeToAcknowledgeTotalSeconds : 0;
                return parseInt(seconds / 60);
            },
            timeToSetSevMinutes() {
                var seconds = this.data.computedTimeToSetSevSeconds === null ? this.data.computedTimeToSetSevSeconds : 0;
                return parseInt(seconds / 60);
            },
            timeToSendCommsMinutes() {
                var seconds = this.data.computedTimeToSetSevSeconds === null ? this.data.computedTimeToSetSevSeconds : 0;
                return parseInt(seconds / 60);
            }
        },
        methods: {
            onOpenKibana() {
                window.open(`https://alerts.kibana.iom.mgsops.com/app/kibana#/discover?_g=(refreshInterval:(pause:!t,value:0),time:(from:now-365d,mode:quick,to:now))&_a=(columns:!(_source),index:cb05d8e0-293e-11e9-b803-c35481b5cc8d,interval:auto,query:(language:lucene,query:'remedy_incident_number:!'${this.$route.params.id}!''))`);
            }
        }
    }
</script>